module.exports = __webpack_public_path__ + "static/img/background.1d6b644c.svg";